
import { mapState, mapMutations, mapActions } from 'vuex'

import MainNav from './MainNav.vue'
import Logo from './Logo.vue'
import MenuIcon from './MenuIcon.vue'
import MobileNav from './MobileNav.vue'
import CartIcon from './CartIcon.vue'
import HandoffModeSelector from '../../../common/HandoffModeSelector'
import Icon from '../../../common/Icon'

export default {
  name: 'SiteHeader',
  components: {
    MainNav,
    Logo,
    MenuIcon,
    MobileNav,
    CartIcon,
    HandoffModeSelector,
    Icon
  },
  props: {
    menu: Array,
    config: Object,
    logos: Object,
    locationIcon: Object,
    chevron: Object,
    rewardsTrophy: Object,
    mobileMenu: Array,
    mobileMenuConfig: Object,
  },
  data() {
    return {
      handoffModes: []
    }
  },
  computed: {
    ...mapState([ 'appInfo', 'user', 'location', 'showNav', 'order', 'cart' ]),
    ...mapState({
      rewards: state => state.members.rewards,
    }),
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    appHandoffModes() {
      return this.appInfo.order['handoff_modes_main_nav']
    },
    locationHandoffModes() {
      if (this.location) {
        return this.$utils.locationHandoffModes(this.location, this.appHandoffModes)
      }
    },
    hasCartProducts() {
      return this.cart && this.cart.products?.length > 0
    },
    checkSize() {
      if (this.isMobile && this.config && this.config.greetings && this.points > this.config.greetings.checkPointsForSize) {
        return false
      }

      return true
    },
    points() {
      if (this.rewards && this.rewards.points) {
        return this.rewards.points.toLocaleString('en-US')
      }
      return 0
    },
    pointsText() {
      if (this.config?.greetings?.points?.pointsText) {
        return !!this.points && this.config.greetings.points.pointsText
      }
      if (this.rewards && this.rewards.units) {
        return this.rewards.units
      }
      return this.points ? 'Points' : 'Point'
    },
  },
  methods: {
    ...mapMutations({
      setHandoffMode: 'order/setHandoffMode'
    }),
    goToReserveTable() {
      this.setHandoffMode('reservation')
      this.$nuxt.$router.push('/locations')
    },
  },
}
